// extracted by mini-css-extract-plugin
module.exports = {"label":"FormLoginValidationCode_label__3Xf_q","required":"FormLoginValidationCode_required__16Xtd"};